export default __webpack_public_path__ + "static/blob4-5c6a86f664357233a0b82eaae5ad9516.svg";